import './Input.css';

import { Input as AntInput } from 'antd';
import PropTypes from 'prop-types';

const Input = ({
  label,
  placeholder,
  type,
  disabled,
  data,
  dataHandler,
  maxLength,
  minLength,
  error,
  className,
  inputClassName,
  inputMode,
  pattern
}) => {
  Input.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.string,
    dataHandler: PropTypes.func,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    className: PropTypes.string,
    inputClassName: PropTypes.string
  };

  return (
    <div className={className ? `helbest-input ${className}` : 'helbest-input'}>
      {label ? <label className={`input-label ${error ? 'error' : ''}`}>{label}</label> : null}
      <AntInput
        allowClear={true}
        bordered={false}
        className={`simple-input ${inputClassName || ''}`}
        disabled={disabled || null}
        inputMode={inputMode}
        maxLength={maxLength || null}
        minLength={minLength || null}
        onChange={(e) => (dataHandler ? dataHandler(e.target.value) : null)}
        pattern={pattern}
        placeholder={placeholder || null}
        type={type || null}
        value={data}
      />
    </div>
  );
};

export default Input;
